"use client";

import '@/styles/modules/contactform.module.scss';
import clsx from 'clsx';
import css from "./lead-form.module.scss";
import * as Api from '@api';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { useMdrRecaptcha } from '@/parts/EuropeanLanderMdrSection/useMdrRecaptcha';


if (typeof window !== "undefined")
{

    // @ts-ignore
    function filledInputInit(e)
    {
        if (e.target)
        {
            e = e.target;
        }

        const parentRow = e.parentElement.parentElement;
        if (e.value)
        {
            parentRow.classList.add('filled');
            parentRow.classList.remove('show-label');
        } else
        {
            parentRow.classList.remove('filled');

            // setTimeout(() => {
            if (!(e.placeholder) && (e.type === 'text' || e.type === 'email' || e.type === 'number' || e.type === 'tel'))
            {
                parentRow.classList.add('show-label');
            }
            else if (e.type === 'password' || e.type === 'select-one')
            {
                parentRow.classList.add('show-label');
            }
            else
            {
                parentRow.classList.remove('show-label');
            }
            // }, "100");

        }
    }

    // window.addEventListener("DOMContentLoaded", () =>{

    const formElements = document.querySelectorAll('#zcwf-custom .fly-label input, #zcwf-custom .fly-label textarea');

    formElements.forEach(e =>
    {
        filledInputInit(e)
        e.addEventListener('input', filledInputInit);
    });
    // });
}

// The submit label is the only thing this reads from the CMS. Asking for no
// more than that lets a page without a standfirst use the form without
// requesting a key it does not have, which would log a missing-key warning.
// Zoho only creates a lead when the post carries the fields its web form marks
// as mandatory, and it answers a post it drops with the same redirect as one it
// keeps. The Zoho form wants "First Name" and "Last Name"; the design has one
// "Name" field, so its value is split into the two as the post is built.
// Every other form that posts to this Zoho form sends a reCAPTCHA token with
// it, so this one does too. The widget is drawn with `grecaptcha.render`, as on
// the MDR form, so it cannot collide with a contact form's own `.g-recaptcha`.
export const LeadForm = ({ pageContent }: {pageContent: Api.Content<"lead-form.button">}) =>
{
    const pathname = usePathname();
    const formRef = useRef<HTMLFormElement>(null);
    const widgetRef = useRef<HTMLDivElement>(null);
    const widgetId = useRef<number | null>(null);
    const [captchaToken, setCaptchaToken] = useState('');
    const [showCaptchaError, setShowCaptchaError] = useState(false);

    const containerRef = useMdrRecaptcha((api) =>
    {
        const el = widgetRef.current;
        if (!el || widgetId.current !== null) { return; }
        widgetId.current = api.render(el, {
            sitekey: process.env.NEXT_PUBLIC_G_RC_SITE_KEY ?? '',
            theme: 'light',
            callback: (token) =>
            {
                setCaptchaToken(token);
                setShowCaptchaError(false);
            },
            'expired-callback': () => setCaptchaToken(''),
        });
    });

    useEffect(() =>
    {
        const form = formRef.current;
        if (!form) { return; }

        const splitName = (event: FormDataEvent) =>
        {
            const fullName = String(event.formData.get('Last Name') ?? '').trim().replace(/\s+/g, ' ');
            const space = fullName.indexOf(' ');
            // A single word goes into both, since Zoho needs each of them filled.
            event.formData.set('First Name', space > 0 ? fullName.slice(0, space) : fullName);
            event.formData.set('Last Name', space > 0 ? fullName.slice(space + 1) : fullName);
        };

        form.addEventListener('formdata', splitName);
        return () => form.removeEventListener('formdata', splitName);
    }, []);

    function validateEmail3956778000036693201()
    {
        // @ts-ignore
        var form = document.forms['WebToLeads3956778000036693201'];
        var emailFld = form.querySelectorAll('[ftype=email]');
        var i;
        for (i = 0; i < emailFld.length; i++)
        {
            var emailVal = emailFld[i].value;
            if ((emailVal.replace(/^\s+|\s+$/g, '')).length != 0)
            {
                const atpos = emailVal.indexOf('@');
                const dotpos = emailVal.lastIndexOf('.');
                if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length)
                {
                    alert('Please enter a valid email address. ');
                    emailFld[i].focus();
                    return false;
                }
            }
        }
        return true;
    }

    function checkMandatory3956778000036693201()
    {
        const selectState = (document.getElementById('LEADCF7') as HTMLInputElement).value;

        if (selectState?.toLowerCase() === 'none'.toLowerCase())
        {
            alert('Please select a state.');
            document.getElementById('LEADCF7')?.focus();
            return false;
        }

        if (!validateEmail3956778000036693201()) { return false; }

        if (!captchaToken)
        {
            setShowCaptchaError(true);
            return false;
        }
        document.querySelector('.crmWebToEntityForm .formsubmit')?.setAttribute('disabled', 'true');
    }

    function tooltipShow3956778000036693201(el: any)
    {
        var tooltip = el.nextElementSibling;
        var tooltipDisplay = tooltip.style.display;
        if (tooltipDisplay == 'none')
        {
            const allTooltip = document.getElementsByClassName('zcwf_tooltip_over');
            for (let i = 0; i < allTooltip.length; i++)
            {
                (allTooltip[i] as HTMLInputElement).style.display = 'none';
            }
            tooltip.style.display = 'block';
        } else
        {
            tooltip.style.display = 'none';
        }
    }

    return (
        <div ref={containerRef} id="crmWebToEntityForm" className="zcwf_lblLeft crmWebToEntityForm _global_Canvas">
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta httpEquiv="content-type" content="text/html;charset=UTF-8" />
            <form action="https://crm.zoho.com/crm/WebToLeadForm" name="WebToLeads3956778000036693201" method="POST" id="zcwf-custom"
                ref={formRef}
                // The check only reports a problem; the post has to be stopped here,
                // or a form with no state chosen goes to Zoho without it and is dropped.
                onSubmit={(event) =>
                {
                    if (checkMandatory3956778000036693201() === false)
                    {
                        event.preventDefault();
                        return;
                    }
                    // Zoho's analytics script only takes over a native onsubmit attribute, which
                    // a React form does not have. Without this call it never learns the form was
                    // sent and reports the visit as abandoned as the page unloads.
                    try
                    {
                        // @ts-ignore
                        window._wfa_track?.wfa_submit({ target: event.currentTarget });
                    }
                    catch {}
                }}
                acceptCharset="UTF-8">
                <input type="text" style={{ display: 'none' }} name="xnQsjsdp"
                    defaultValue="8d36882323914fbe3ecbdaaea2bfc4e01f117fbfe08b3ca251da01b4b356cb59" />
                <input type="hidden" name="zc_gad" id="zc_gad" defaultValue={'true'} />
                <input type="text" style={{ display: 'none' }} name="xmIwtLD"
                    defaultValue="ed451fe54765c6d2d15ef95a78bbc9f32f3a8f91b8714f37e89d66a701f7fe98" />
                <input type="text" style={{ display: 'none' }} name="actionType" defaultValue="TGVhZHM=" />
                <input type="text" style={{ display: 'none' }} name="returnURL"
                    defaultValue="https://active710.com/thankyou-contact" />
                {/* The page the lead came from and its source, as the site contact form sends them. */}
                <input type="text" style={{ display: 'none' }} id="LEADCF9" name="LEADCF9"
                    value={pathname ?? '/'} readOnly />
                <input type="text" style={{ display: 'none' }} name="Lead Source" defaultValue="AVD Website" />
                {/* Do not remove this code. */}
                {/*<div className="zcwf_title" style={{maxWidth: '600px', color: 'black'}}>Leads Form</div>*/}
                <div className="zcwf_rows-col">
                    <div className="zcwf_row fly-label">
                        <div className="zcwf_col_lab">
                            <label htmlFor="Name">Name<span>*</span></label>
                        </div>
                        <div className="zcwf_col_fld">
                            {/* Posted as "Last Name" so a lead is still created if the split in the formdata handler never runs. */}
                            <input type="text" id="Name" placeholder="Name*"
                                name="Last Name" maxLength={80} required />
                            <div className="zcwf_col_help" />
                        </div>
                    </div>
                </div>
                <div className="zcwf_row fly-label">
                    <div className="zcwf_col_lab">
                        <label htmlFor="Email">Email<span>*</span></label>
                    </div>
                    <div className="zcwf_col_fld">
                        <input type="email" ftype="email" placeholder="Email*" id="Email"
                            name="Email" maxLength={100} required />
                        <div className="zcwf_col_help" />
                    </div>
                </div>
                <div className="zcwf_rows-col">
                    <div className="zcwf_row fly-label">
                        <div className="zcwf_col_lab">
                            <label htmlFor="Company">Company<span>*</span></label>
                        </div>
                        <div className="zcwf_col_fld">
                            <input type="text" id="Company" placeholder="Company*" name="Company"
                                maxLength={200} required />
                            <div className="zcwf_col_help" />
                        </div>
                    </div>
                    <div className="zcwf_row fly-label">
                        <div className="zcwf_col_lab">
                            <label htmlFor="Designation">Job Title<span>*</span>
                            </label>
                        </div>
                        <div className="zcwf_col_fld">
                            <input type="text" placeholder="Job Title*" id="Designation"
                                name="Designation" maxLength={100} required />
                            <div className="zcwf_col_help" />
                        </div>
                    </div>
                </div>
                <div className="zcwf_rows-col">
                    <div className="zcwf_row fly-label">
                        <div className="zcwf_col_lab">
                            <label htmlFor="Phone">Phone<span>*</span></label>
                        </div>
                        <div className="zcwf_col_fld">
                            <input type="text" id="Phone" placeholder="Phone*" name="Phone"
                                maxLength={30} required />
                            <div className="zcwf_col_help" />
                        </div>
                    </div>
                    <div className="zcwf_row fly-label">
                        <div className="zcwf_col_lab">
                            <label htmlFor="LEADCF7">State<span>*</span></label>
                        </div>
                        <div className="zcwf_col_fld">
                            <select className="zcwf_col_fld_slt" id="LEADCF7" name="LEADCF7"
                                required defaultValue={'none'}>
                                <option value="none" disabled>State*</option>
                                <option value="MSO">MSO</option>
                                <option value="Single State Operator">Single State Operator</option>
                                <option value="Canadian LP">Canadian LP</option>
                                <option value="3rd Party Processing/Packaging">3rd Party Processing/Packaging
                                </option>
                                <option value="Dispensary">Dispensary</option>
                                <option value="U.S. Distributor">U.S. Distributor</option>
                                <option value="International Distributor">International Distributor</option>
                                <option value="International Operator">International Operator</option>
                                <option value="Consultant">Consultant</option>
                                <option value="Legacy">Legacy</option>
                                <option value="Alabama">Alabama</option>
                                <option value="Alaska">Alaska</option>
                                <option value="Arizona">Arizona</option>
                                <option value="Arkansas">Arkansas</option>
                                <option value="California">California</option>
                                <option value="Colorado">Colorado</option>
                                <option value="Connecticut">Connecticut</option>
                                <option value="Delaware">Delaware</option>
                                <option value="Florida">Florida</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Hawaii">Hawaii</option>
                                <option value="Idaho">Idaho</option>
                                <option value="Illinois">Illinois</option>
                                <option value="Indiana">Indiana</option>
                                <option value="Iowa">Iowa</option>
                                <option value="Kansas">Kansas</option>
                                <option value="Kentucky">Kentucky</option>
                                <option value="Louisiana">Louisiana</option>
                                <option value="Maine">Maine</option>
                                <option value="Maryland">Maryland</option>
                                <option value="Massachusetts">Massachusetts</option>
                                <option value="Michigan">Michigan</option>
                                <option value="Minnesota">Minnesota</option>
                                <option value="Mississippi">Mississippi</option>
                                <option value="Missouri">Missouri</option>
                                <option value="Montana">Montana</option>
                                <option value="Nebraska">Nebraska</option>
                                <option value="Nevada">Nevada</option>
                                <option value="New Hampshire">New Hampshire</option>
                                <option value="New Jersey">New Jersey</option>
                                <option value="New Mexico">New Mexico</option>
                                <option value="New York">New York</option>
                                <option value="North Carolina">North Carolina</option>
                                <option value="North Dakota">North Dakota</option>
                                <option value="Ohio">Ohio</option>
                                <option value="Oklahoma">Oklahoma</option>
                                <option value="Oregon">Oregon</option>
                                <option value="Pennsylvania">Pennsylvania</option>
                                <option value="Rhode Island">Rhode Island</option>
                                <option value="South Carolina">South Carolina</option>
                                <option value="South Dakota">South Dakota</option>
                                <option value="Tennessee">Tennessee</option>
                                <option value="Texas">Texas</option>
                                <option value="Utah">Utah</option>
                                <option value="Vermont">Vermont</option>
                                <option value="Virginia">Virginia</option>
                                <option value="Washington">Washington</option>
                                <option value="West Virginia">West Virginia</option>
                                <option value="Wisconsin">Wisconsin</option>
                                <option value="Wyoming">Wyoming</option>
                            </select>
                            <div className="zcwf_col_help" />
                        </div>
                    </div>
                </div>
                <div className="zcwf_row fly-label">
                    <div className="zcwf_col_lab">
                        <label htmlFor="LEADCF8">Lead&apos;s Message</label>
                    </div>
                    <div className="zcwf_col_fld">
                        <textarea id="LEADCF8"
                            placeholder="What was going on with your company that brought you here today to test new hardware?"
                            name="LEADCF8" defaultValue={""} />
                        <div className="zcwf_col_help" />
                    </div>
                </div>
                {/* <div className="zcwf_row fly-label sr-only">
                    <div className="zcwf_col_lab">
                        <label htmlFor="Lead_Source">Lead Source</label>
                    </div>
                    <div className="zcwf_col_fld">
                        <select className="zcwf_col_fld_slt" id="Lead_Source"
                            name="Lead Source" defaultValue={'AVD Website'}>
                            <option value="-None-">-None-</option>
                            <option value="AVD Website">AVD Website</option>
                            <option value="AVD Phone Sales Line">AVD Phone Sales Line</option>
                            <option value="Sales Outreach">Sales Outreach</option>
                            <option value="Affiliate Sales Person">Affiliate Sales Person</option>
                            <option value="Instagram">Instagram</option>
                            <option value="LinkedIn">LinkedIn</option>
                            <option value="Trade Shows">Trade Shows</option>
                        </select>
                        <div className="zcwf_col_help" />
                    </div>
                </div> */}
                <div className="zcwf_row zcwf_row-checkbox" style={{ maxWidth: "286px" }}>
                    <input type="checkbox" className="zcwf_ckbox" defaultChecked={true} id="LEADCF109"
                        name="LEADCF109"
                        maxLength={3} />
                    <label htmlFor="LEADCF109">Join the leading brands. Get product updates &amp; other news.
                        Unsubscribe
                        anytime. Visit our <a href="/policy/privacy-policy" target="_blank">Privacy Policy</a> for more
                        information.</label>
                </div>
                <div className="zcwf_row" style={{ minHeight: 78 }}>
                    <div ref={widgetRef} />
                    {showCaptchaError && (
                        <div className={css["captcha_error"]} role="alert">Captcha
                            validation failed. If you are not a robot then please try again.
                        </div>
                    )}
                </div>
                <div className="zcwf_row">
                    <button type="submit" id="formsubmit" className={clsx("formsubmit", "zcwf_button", "btn-yellow")}>{pageContent["lead-form.button"]?.data || "Start an exclusive product design"}</button>
                </div>
                {/* Do not remove this --- Analytics Tracking code starts */}
                <script async id='wf_anal'
                    src='https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=ed451fe54765c6d2d15ef95a78bbc9f32f3a8f91b8714f37e89d66a701f7fe98gid8d36882323914fbe3ecbdaaea2bfc4e01f117fbfe08b3ca251da01b4b356cb59gid885e3c1045bd9bdcc91bdf30f82b5696gid14f4ec16431e0686150daa43f3210513&tw=61690b96c1d0471b638f31426f38e68aa67fb7ed6da86f32dc10ad817fe55a0a'></script>
                {/* Do not remove this --- Analytics Tracking code ends. */}
            </form>
        </div>
    );
}